// import React from "react";
// import { Link } from "react-router-dom";

// const EditUser = () => {
//   return (
//     <div className="dashboardWrp">
//       <div className="uk-container uk-container-small">
//         <div className="dashboardTop">
//           <div uk-grid="" className="uk-grid uk-grid-small">
//             <div className="uk-width-2-3">
//               <div className="dashboardIntro">
//                 <Link to="/user-teams">
//                   <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
//                   <span>Back to all teams</span>
//                 </Link>
//               </div>
//             </div>
//           </div>

//           <div
//             className="uk-grid uk-grid-small"
//             uk-grid=""
//             uk-height-match="target: div .formCreateMain2"
//           >
//             <div className="uk-width-expand@m">
//               <form>
//                 <div className="formCreateMain2">
//                   <div className="uk-card uk-card-default uk-card-small uk-card-body">
//                     <div className="uk-grid uk-grid-small">
//                       <div className="uk-width-1-1@m uk-margin-top">
//                         <div className="profile">
//                           <img
//                             src="./assets/images/zong/profilepic.svg"
//                             uk-svg=""
//                           />
//                           <span className="picUpload">
//                             <img
//                               src="./assets/images/zong/camera.svg"
//                               uk-svg=""
//                             />
//                           </span>
//                           <div className="profileStatus">
//                             <ul>
//                               <li className="online">
//                                 <span>
//                                   Online{" "}
//                                   <img
//                                     src="./assets/images/zong/Group175724.svg"
//                                     uk-svg=""
//                                   />
//                                 </span>
//                               </li>
//                             </ul>
//                           </div>

//                           <div className="profieInfo">
//                             <input
//                               className="uk-input"
//                               type="text"
//                               placeholder="Fist name"
//                               aria-label="Input"
//                               value="Yumna Zaidi"
//                             />
//                             <input
//                               className="uk-input"
//                               type="text"
//                               placeholder="Enter title"
//                               aria-label="Input"
//                             />
//                             <input
//                               className="uk-input"
//                               type="text"
//                               placeholder="Enter phone number"
//                               aria-label="Input"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//             </div>

//             <div className="uk-width-3-5@m">
//               <div className="formCreateMain agentCreateMain">
//                 <div className="uk-card -uk-card-default uk-card-small uk-card-body">
//                   <div className="head">
//                     <h5 className="uk-heading-divider">Agent profile</h5>
//                   </div>

//                   <div className="head">
//                     <h6>Usage summary</h6>
//                     <div className="overCardTxt agentProfile">
//                       <p>
//                         <span>
//                           Inbound minutes <b>127</b>
//                         </span>
//                         <span>
//                           Outbound minutes <b>127</b>
//                         </span>
//                       </p>
//                     </div>
//                   </div>

//                   <div className="head">
//                     <h6>Account information</h6>
//                     <div className="overCardTxt agentProfile">
//                       <p>
//                         <span>
//                           {" "}
//                           <img
//                             src="./assets/images/zong/identification.svg"
//                             uk-svg=""
//                           />{" "}
//                           Last login <b>14/07/2022</b>
//                         </span>
//                         <span>
//                           {" "}
//                           <img
//                             src="./assets/images/zong/identification.svg"
//                             uk-svg=""
//                           />
//                           Last password change <b>14/07/2022</b>
//                         </span>
//                       </p>
//                     </div>
//                   </div>

//                   <div className="uk-margin-top">
//                     <div className="head">
//                       <div className="overCardTxt agentProfile">
//                         <p>
//                           <span>
//                             Enabled Agent <b>14/07/2022 at 07:55 PM</b>
//                           </span>
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="uk-width-1-1@m">
//               <form>
//                 <div className="formCreateMain">
//                   <div className="uk-grid uk-grid-small">
//                     <div className="uk-width-1-1@m uk-margin-top">
//                       <legend className="uk-legend">User information</legend>
//                     </div>
//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Fist name</label>
//                       <input
//                         className="uk-input"
//                         type="text"
//                         placeholder="Fist name"
//                         aria-label="Input"
//                       />
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Last name</label>
//                       <input
//                         className="uk-input"
//                         type="text"
//                         placeholder="Last name"
//                         aria-label="Input"
//                       />
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Work number</label>
//                       <input
//                         className="uk-input"
//                         type="text"
//                         placeholder="Work number"
//                         aria-label="Input"
//                       />
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Mobile Number</label>
//                       <input
//                         className="uk-input"
//                         type="text"
//                         placeholder="Mobile Number"
//                         aria-label="Input"
//                       />
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Email</label>
//                       <input
//                         className="uk-input"
//                         type="text"
//                         placeholder="Email address"
//                         aria-label="Input"
//                       />
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Team</label>
//                       <select className="uk-select" aria-label="Select">
//                         <option value="" selected disabled hidden>
//                           Select team
//                         </option>
//                         <option>Option 01</option>
//                         <option>Option 02</option>
//                       </select>
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Admin Role</label>
//                       <textarea
//                         className="uk-textarea"
//                         rows="5"
//                         placeholder="Textarea"
//                         aria-label="Textarea"
//                       >
//                         Manages everything related to account access and
//                         security. Assign this role to users who manage users and
//                         teams of users, apply restrictions with two-factor
//                         authentication, password policies and API keys.
//                       </textarea>
//                     </div>

//                     <div className="uk-width-1-2@m uk-margin-top">
//                       <label>Admin Role Status</label>
//                       <span className="switchToggle">
//                         <input type="checkbox" />
//                       </span>
//                     </div>

//                     <div className="uk-width-1-1@m uk-float-right">
//                       <div className="formActionBtn uk-text-right">
//                         <button className="whiteBtn">Cancel</button>
//                         <button className="pinkBtn">Save</button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditUser;

import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { url } from "../../../Constant";
import axios from "axios";
import { useAuth } from "../../../Context/AuthProvider";
import { toast } from "react-toastify";
import { ValidateEmail } from "../../../Utils/regexFunctions";
import "../../../assets/css/style.css";
import "../../../assets/css/uikit.min.css";


const EditUser = () => {
  const { auth } = useAuth();
  const params = useParams();
  const [pages, setPages] = useState();
  const [loader, setLoader] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [errorEnable, setErrorEnable] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [pwdPassword, setPwdPassword] = useState(true);
  const [submittedData, setSubmittedData] = useState({
    name: "",
    email: "",
    password: "",
    password_confirm: "",
  });

  const handleConfirmPwdValidation = (e) => {
    if (e === submittedData.password && e.length >= 5) {
      setPwdPassword(true);
    } else {
      setPwdPassword(false);
    }
  };
  const handlePasswordValidation = (e) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/;
    let testedPassword = passwordRegex.test(e);
    if (testedPassword === false) {
      setPasswordError("Validation error");
    } else if (e.length < 14) {
      setPasswordError("Invalid password");
    } else {
      setPasswordError("");
    }
  };

  const getSingleUser = () => {
    axios
      .post(
        url + "view-user-by-id",
        {
          user_id: params.id,
          vpbx_id: auth.vpbx_id,
        },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          handleEmailValidation(response.data.data.email);
          setSubmittedData({
            name: response.data.data.name,
            email: response.data.data.email,
            password: response.data.data.org_password,
            password_confirm: response.data.data.org_password,
          });
          // setPages()
          setPages(response.data.data.access_permission);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getSingleUser();
  }, []);

  const handleChangeRoleToggle = (rights, index, onOff) => {
    var tempData = [...pages];
    tempData[index][rights] = onOff;
    setPages(tempData);
  };

  const handleEmailValidation = (e) => {
    var Email = ValidateEmail(e);
    if (Email === "Invalid Email") {
      setEmailError("Invalid Email Address");
    } else {
      setEmailError("Valid Email Address");
    }
  };

  const addUserRole = (e) => {
    e.preventDefault();
    setLoader(true);
    setErrorEnable(true);

    if (
      submittedData.name !== "" &&
      submittedData.email !== "" &&
      submittedData.password !== "" &&
      submittedData.password_confirm !== "" &&
      pwdPassword === true &&
      passwordError === "" &&
      emailError === "Valid Email Address"
    ) {
      axios
        .post(
          url + "update-user",
          {
            user_id: params.id,
            vpbx_id: auth.vpbx_id,
            name: submittedData.name,
            email: submittedData.email,
            password: submittedData.password,
            password_confirm: submittedData.password_confirm,
            role_permissions: pages,
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        )
        .then(
          (response) => {
            if (response.data.code === 200) {
              setLoader(false);
              toast.success("User role updated successfully", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1500,
              });
            } else {
              setLoader(false);

              if (response.data.data.hasOwnProperty("email") === true) {
                response.data.data.email.map((val, index) => {
                  return toast.error(val, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1500,
                  });
                });
              } else {
                toast.error(response?.data?.message, {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link
                  onClick={() => {
                    window.location.href = "/user";
                  }}
                >
                  <img src="/assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to all Users</span>
                </Link>
                <h3>Edit User</h3>
                {/* <p>You can add up to 10 users below by entering their phone or email addresses.</p> */}
              </div>
            </div>
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">User information</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Name</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="please enter name"
                    aria-label="Input"
                    value={submittedData.name}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        name: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.name === "" && (
                    <div className="formErrors">Name is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Email</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Email address"
                    aria-label="Input"
                    value={submittedData.email}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        email: e.target.value,
                      });
                      handleEmailValidation(e.target.value);
                    }}
                  />
                  {errorEnable && submittedData.email === "" && (
                    <div className="formErrors">Email is required</div>
                  )}
                  {submittedData.email !== "" &&
                    errorEnable &&
                    emailError !== "Valid Email Address" && (
                      <div className="formErrors">Invalid Email Address</div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Password</label>
                  <input
                    className="uk-input"
                    type="password"
                    placeholder="please enter password"
                    aria-label="Input"
                    value={submittedData.password}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password: e.target.value,
                      });
                      handlePasswordValidation(e.target.value);
                    }}
                  />

                  {errorEnable && submittedData.password === "" && (
                    <div className="formErrors">Password is required</div>
                  )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Invalid password" && (
                      <div className="formErrors">
                        password must be 14 characters
                      </div>
                    )}
                  {submittedData.password !== "" &&
                    errorEnable &&
                    passwordError === "Validation error" && (
                      <div className="formErrors">
                        password must includes uppercase, lowercase, numbers and
                        special characters
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Confirm password</label>
                  <input
                    className="uk-input"
                    type="password"
                    placeholder="please enter confirm password"
                    aria-label="Input"
                    value={submittedData.password_confirm}
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        password_confirm: e.target.value,
                      });
                      handleConfirmPwdValidation(e.target.value);
                    }}
                  />

                  {errorEnable && submittedData.password_confirm === "" && (
                    <div className="formErrors">
                      Confirm Password is required
                    </div>
                  )}
                  {submittedData.password_confirm !== "" &&
                    errorEnable &&
                    pwdPassword === false && (
                      <div className="formErrors">
                        password and confirm password not matched{" "}
                      </div>
                    )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Pages</label>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <label>Read Only</label>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <label>Read/Write</label>
                </div>

                {pages?.map((val, index) => {
                  return (
                    <>
                      <div className="uk-width-1-2@m uk-margin-top">
                        <label>{val.page_name}</label>
                      </div>
                      <div className="uk-width-1-4@m uk-margin-top">
                        <span className="switchToggle">
                          <input
                            type="checkbox"
                            checked={val.read_only === 1 ? true : false}
                            onChange={() =>
                              handleChangeRoleToggle(
                                "read_only",
                                index,
                                val.read_only === 1 ? 0 : 1
                              )
                            }
                          />
                        </span>
                      </div>
                      <div className="uk-width-1-4@m uk-margin-top">
                        <span className="switchToggle">
                          <input
                            type="checkbox"
                            checked={val.read_and_write === 1 ? true : false}
                            onChange={() =>
                              handleChangeRoleToggle(
                                "read_and_write",
                                index,
                                val.read_and_write === 1 ? 0 : 1
                              )
                            }
                          />
                        </span>
                      </div>
                    </>
                  );
                })}
                {/* <div className="uk-width-1-2@m uk-margin-top">
                  <label>Admin Role</label>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <span className="switchToggle">
                    <input type="checkbox" />
                  </span>
                </div>
                <div className="uk-width-1-4@m uk-margin-top">
                  <span className="switchToggle">
                    <input type="checkbox" />
                  </span>
                </div> */}

                <div className="uk-width-1-1@m uk-float-right uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    <button
                      className="whiteBtn"
                      onClick={() => (window.location.href = "/user")}
                    >
                      Cancel
                    </button>
                    <button className="pinkBtn" onClick={addUserRole}>
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Edit User"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
